import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { LicenseSubFormComponent } from '../../types/LicenseSubFormComponent';
import { LicenseFratSubFormController } from '../controller/LicenseFratSubFormController';
import { Observable } from 'rxjs';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { CompanyData } from '../../../company/types/company-data';

export class LicenseFratSubFormWebComponent extends BaseWebComponentElement implements LicenseSubFormComponent {
  public controller!: LicenseFratSubFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseFratSubFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get value(): FormGroupValue {
    return this.controller.view.formGroup.value;
  }

  public setViewData(): void {
    //no-op
  }

  public setCompanyData(company: CompanyData): void {}
}
